interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  label: string;
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
}

export function FilterChips<T extends string>({ label, options, value, onChange }: Props<T>) {
  return (
    <div className="sr-filter">
      <span className="sr-filter__label">{label}:</span>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`sr-filter__chip${value === opt.value ? " is-active" : ""}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
